export default __webpack_public_path__ + "static/media/refazer.0b384bfb.svg";